<template>
    <div style="overflow-x:hidden">
        <BannerStatic :ban="wWidth<768?banner[1]:banner[0]"></BannerStatic>
        
        <Contact class="px-xs-32"></Contact>
    </div>
</template>

<script>
import BannerStatic from '@/components/header/bannerStatic.vue'
import Contact from '@/components/contact/contact.vue'
export default {
    components:{
        BannerStatic,
        Contact
    },
    data(){
        return{
            banner: [require('@/assets/employ/new-2.1.jpg'),require('@/assets/phone/bannerCO.png')],
            wWidth: window.screen.width
        }
    }
}
</script>